import useModal from "../../hooks/useModal";
import LandingTemplate from "../../templates/LandingTemplate/LandingTemplate";
import FormModal from "../../components/organisms/FormModal/FormModal";
import AlertModal from "../../components/organisms/AlertModal/AlertModal";
import { Helmet } from "react-helmet-async";
const LandingScreen = () => {
  const accessModal = useModal();
  const alertModal = useModal();

  return (
    <>
     <Helmet>
        <title>Ensemble pour la Forêt | Prévention et surveillance des risques d'incendie</title>
        <meta
          name="description"
          content="Plateforme de suivi du risque incendie en France, développée par l'EDHEC Climate Institute et Climate Innov. Anticipez, surveillez, protégez."
        />
      </Helmet>
      <LandingTemplate
        onRequestAccess={accessModal.open}
        onSubscribeAlerts={alertModal.open}
      />
      <FormModal isOpen={accessModal.isOpen} onClose={accessModal.close} />
      <AlertModal isOpen={alertModal.isOpen} onClose={alertModal.close} />
    </>
  );
};

export default LandingScreen;
